/**
 * Copyright Motili Inc., 2025 All Rights Reserved
 */

/**
 * Detects if the app is running under Cypress test environment
 * Uses multiple detection methods for reliability:
 * 1. localStorage flag (most reliable - set by Cypress commands)
 * 2. window.Cypress object (standard method)
 * 3. Parent window check (Cypress runs in iframe)
 *
 * @returns {boolean} true if running in Cypress environment
 */
export function isCypressEnvironment() {
    if (typeof window === 'undefined') {
        return false;
    }

    // Method 1: Check localStorage flag (most reliable)
    // This is set by our Cypress commands before the app loads
    const cypressFlag = window.localStorage.getItem('__CYPRESS_TEST__');
    if (cypressFlag === 'true') {
        return true;
    }

    // Method 2: Check window.Cypress object (standard method)
    if (window.Cypress) {
        return true;
    }

    // Method 3: Check if running in Cypress iframe
    // Cypress runs the app in an iframe, so window.top !== window.self
    if (window.top !== window.self && window.parent.Cypress) {
        return true;
    }

    return false;
}

/**
 * Attaches the Redux store to window.Cypress for Cypress tests
 * @param {object} store - Redux store instance
 * @param {object} persistor - Redux persistor instance (optional)
 */
export function attachStoreForCypress(store, persistor) {
    if (!isCypressEnvironment() || !store) {
        return;
    }

    // Attach to window.Cypress.reduxStore (expected by Cypress commands)
    window.reduxStore = store;
    if (persistor) {
        window.reduxPersistor = persistor;
    }
}
